import type { IconData } from '@stacksjs/iconify-core'

export const arrowThickToTop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M56 297.365V336h120v160h160V336h120v-38.626l-199.8-200ZM304 304v160h-96V304H94.639l161.535-161.37L417.384 304ZM56 16.002h400v32H56z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default arrowThickToTop
